import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getComboTipoInstalacionPadre`, method: 'GET', body: null, token: token})
}